// Constants
import {
  INTENTIONAL_NAVIGATION,
  INTENTIONAL_NAVIGATION_ON,
} from 'components/header-layout/constants/header-layout.constants';
// Translations
import { BUTTON } from '../translations/payment-error.translations';
// Types
import {
  PaymentErrorBuilderHandlersType,
  PaymentErrorMethodsHandlersType,
} from './types/payment-error.handlers.type';

const retryButtonClickHandler = (): void => {
  localStorage.setItem(INTENTIONAL_NAVIGATION, INTENTIONAL_NAVIGATION_ON);
  window.location.reload();
};

const setupPaymentErrorButtonConfigurationHandler = ({
  formatMessage,
  handleTrackPaymentErrorTryAgain,
  setMainButtonConfiguration,
}: PaymentErrorBuilderHandlersType): void => {
  setMainButtonConfiguration({
    children: formatMessage({ id: BUTTON }),
    onClick: () => {
      handleTrackPaymentErrorTryAgain();
      retryButtonClickHandler();
    },
  });
};

const PaymentErrorHandlers = (
  props: PaymentErrorBuilderHandlersType
): PaymentErrorMethodsHandlersType => ({
  handleSetupPaymentErrorButtonConfiguration: () =>
    setupPaymentErrorButtonConfigurationHandler(props),
});

export { PaymentErrorHandlers };
